// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ProjectTemplateSchema } from './v1/projectTemplateSchema';
import { v1ProjectTemplatesCreateSchema } from './v1/projectTemplates/createSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const createProjectTemplatePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createProjectTemplateHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Project template created successfully
 */
export const createProjectTemplate201Schema = z.lazy(() => v1ProjectTemplateSchema);

/**
 * @description Validation failed
 */
export const createProjectTemplate422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createProjectTemplateMutationRequestSchema = z.lazy(() => v1ProjectTemplatesCreateSchema);

export const createProjectTemplateMutationResponseSchema = z.lazy(() => createProjectTemplate201Schema);
